<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes surfer-1 {
    0%,
    25% {
      opacity: 1;
    }
    25%,
    50% {
      opacity: 0;
    }
    50%,
    75% {
      opacity: 1;
    }
    75%,
    100% {
      opacity: 0;
    }
  }
  #surfer-1 {
    animation-name: surfer-1;
  }
  @keyframes surfer-2 {
    0%,
    25% {
      opacity: 0;
    }
    25%,
    50% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #surfer-2 {
    animation-name: surfer-2;
  }
  @keyframes surfer-3 {
    0%,
    75% {
      opacity: 0;
    }
    75%,
    100% {
      opacity: 1;
    }
  }
  #surfer-3 {
    animation-name: surfer-3;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 620.3 399.7" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="surfer-3">
      <path
        fill="var(--hair)"
        d="M372 339c2 0 2 2 2 3a7 7 0 0 0 3 6c8 9 17 17 28 21l7 5v2c-8 7-17 7-26 4l-36-12c-4 0-5-2-4-6 1-8 5-15 7-22 2 1 2 2 2 4a44 44 0 0 0 1 5c1 3 2 4 5 3 4-1 6-4 6-6-1-4 0-6 5-7Z"
      />
      <path
        fill="var(--flesh)"
        d="M372 339c-5 1-6 3-5 7 0 2-2 5-6 6-3 1-4 0-5-3a44 44 0 0 1-1-5c0-2 0-3-2-4 2-10 3-20 2-30-1-11-2-21 3-32l2-8c3-4 2-7-2-10-7-5-13-12-21-16a20 20 0 0 0-4-3 2 2 0 0 0-1-1c-4-1-4-3-1-5l10-10 2-3c-2-1-2 0-3 1-4 5-9 6-14 3a12 12 0 0 0-6-1c-8 0-15 0-23-2l-14-2a15 15 0 0 0-5-1l-3-2-19-7c-13-4-17-13-18-25-1-4 0-8-2-11 1-4 0-9-1-13l-4-22a46 46 0 0 0 5-2c5-1 10-2 14 0a57 57 0 0 0 11 5c5 2 5 4 5 8v24l1 4c4 4 7 9 12 12a86 86 0 0 0 16 7v1l20 4c9 2 18 4 25-5a10 10 0 0 1 10-4 3 3 0 0 0 3-1c3 3 6 1 9 1 5-1 7-3 5-8l-4-8a180 180 0 0 1-13-28c3-3 6-6 10-7l4-3 10-10c5 9 9 19 10 30a17 17 0 0 0 4 9 56 56 0 0 1 7 13 43 43 0 0 1 3 14 10 10 0 0 0 0 5c2 3 1 7 2 11 1 5-6 12-12 12l-8 1c-1 0-2 1-1 2 1 5 3 8 8 11 6 4 7 11 6 18-3 11-4 23-6 34a154 154 0 0 1-10 34 86 86 0 0 0-5 15Z"
      />
      <path
        fill="var(--shirt)"
        d="m374 130-10 10-4 3c-4 1-7 4-10 7-6-1-4-7-7-9 0 4 1 8-1 13l-2 16-1 13c0 9-7 16-17 16l-27-1a86 86 0 0 1-16-7c-5-3-8-8-12-12l-1-3v-24c0-5 0-7-5-9a57 57 0 0 1-11-4c-4-2-9-2-14 0a46 46 0 0 1-5 1v-26c1-10 6-18 13-26 12-13 28-19 46-23a3 3 0 0 1 0 3c-4 7-1 14 1 21 2 8 6 14 10 21 2 2 3 4 6 4h6c3 0 4-1 4-4l3-8c1-3 3-3 5-3 4 1 6-1 8-4 3-6 5-11 9-16l14 13c8 10 15 20 20 32 1 2-2 4-2 6Z"
      />
      <path
        fill="var(--flesh)"
        d="M195 354c3-15 0-30-2-44-2-11-4-23-2-34l6-24a16 16 0 0 1 2-8c6-8 9-18 14-27l7-10 2-1c7-4 11-3 16 2 8 8 14 17 20 26 2 1 1 2-1 3-3 2-6 3-8 6a30 30 0 0 0-12 9l-14 16a5 5 0 0 0-1 5c3 19-1 36-8 54a47 47 0 0 0-2 23v6a16 16 0 0 1-2 3c-1 1-2 3-4 3s-2-2-2-4c0-3-2-4-4-4h-5ZM342 79c-4 5-6 10-9 16-2 3-4 5-8 4-2 0-4 1-5 3l-2 8c-1 3-2 4-5 4h-6c-3 0-4-2-6-4-4-7-8-13-10-21-2-7-5-14-1-21a3 3 0 0 0 0-3c3 0 3-2 3-5 3 0 2-2 2-4 0-4 0-8 2-12 1-2 2-4 5-3s6 3 6 7a26 26 0 0 1 0 9l1 2c1 1 1 0 2-1l4-7c2-3 4-7 8-8 3-1 4-2 4-5a24 24 0 0 1 0-4c1-6 4-9 10-7l11 6c3 2 6 3 9 0 0 7-2 14-3 20a5 5 0 0 1-3 4c-5 3-5 7-4 12a29 29 0 0 1 0 5c0 4-2 5-5 5Z"
      />
      <path
        fill="var(--hair)"
        d="M357 33c-3 3-6 2-9 0l-11-6c-6-2-9 1-10 7a24 24 0 0 0 0 4c0 3-1 4-4 5-4 1-6 5-8 8l-4 7c-1 1-1 2-2 1l-1-2a26 26 0 0 0 0-9c0-4-3-5-6-7s-4 1-5 3c-2 4-2 8-2 12 0 2 1 4-2 4-2-10-4-20-4-30 0-8 4-15 8-21a7 7 0 0 1 4-3c7-2 12-7 20-6 9 1 16 4 24 9 5 3 10 7 15 8 4 1 4 4 4 7-1 4-4 7-7 9ZM195 354h5c2 0 4 1 4 4 0 2 0 3 2 4s3-2 4-3a16 16 0 0 0 2-3l2 11c1 2-1 4-2 6a45 45 0 0 0-11 15c-4 7-17 11-25 8a7 7 0 0 1-4-7c0-5 2-10 5-13l18-22Z"
      />
      <path
        fill="var(--pants)"
        d="M249 243c2-3 5-4 8-6 2-1 3-2 1-3-6-9-12-18-20-26-5-5-9-6-16-2l-2 1a5 5 0 0 1 1-3c4-3 6-7 7-11 0-3 1-5 4-7 1-1 2-2 1-4-3-4 0-5 3-7 2 3 1 7 2 11 1 12 5 21 18 25l19 7 2 2a92 92 0 0 0-9 28c-1 5-1 4-6 2a93 93 0 0 1-13-7ZM297 223c8 2 15 2 23 2a12 12 0 0 1 6 1c5 3 10 2 14-3 1-1 1-2 3-1l-2 3-10 10c-3 2-3 4 1 5a2 2 0 0 1 1 1c-6 5-13 5-19 6a2 2 0 0 1-2-1l-15-22v-1ZM340 170a13 13 0 0 1 6 4c3 2 3 5 0 7-2 2-2 7 1 8 2 1 5 2 6 4a3 3 0 0 1-3 1 10 10 0 0 0-10 4c-7 9-16 8-25 6l-20-5h27c10 0 17-7 17-16l1-13Z"
      />
    </g>
    <g id="surfer-2">
      <path
        fill="var(--flesh)"
        d="M393 227c-1-4 0-8-2-11a10 10 0 0 1 0-5 43 43 0 0 0-3-14 57 57 0 0 0-7-13 17 17 0 0 1-4-9c-1-11-5-21-10-30l-10 10-4 3c-4 1-7 4-10 7a180 180 0 0 0 13 28l4 8c2 5 1 5-4 5l-22-5 3 6c2 2-1 0-2 0 0 6 7 13 7 19l18 6c9 1 23 4 32 0a8 8 0 0 0 1-5ZM388 269c-6-10-19-21-25-22-12-1-15 14-25 10a106 106 0 0 1-5 13 2 2 0 0 1 0 1 19 19 0 0 1 4 2c8 5 10 10 6 18-5 9 14 8 17 8s-1 6-2 9c-5 10-4 20-3 31 1 10 0 20-2 30 2 1 2 3 2 4a44 44 0 0 0 1 5c1 3 2 4 5 4 4-1 6-4 6-7-1-4 0 3 4 2l6-23a154 154 0 0 0 10-35l6-34c1-6 0-12-5-16Z"
      />
      <path
        fill="var(--hair)"
        d="M419 362c-3-1-13-9-16-8-12 3-15 13-27 10a9 9 0 0 1-2-1 35 35 0 0 1-3 6 10 10 0 0 1-5 5 9 9 0 0 1-1 1c-2 2-4 2-6 0l-2-2a9 9 0 0 1-4-4 3 3 0 0 0-1 0c1 4-4 11-3 16 0 3 2 4 3 7 2 4 8 4 11 3 12-4 25-6 37-8 9-2 18-7 21-17l-2-8Z"
      />
      <path
        fill="var(--flesh)"
        d="M199 372c4-15-4-18-6-33-2-11-4-22-2-34l6-24a16 16 0 0 1 2-8c6-8 9-18 14-27l7-10 2-1c7-3 11-3 16 2 8 8 14 17 20 26 2 2 1 3-1 4-3 1 7 6 4 9l-13 10c-4 6-20 6-25 12a5 5 0 0 0-1 4c3 19-1 37-8 54-3 7 2 5 3 13v5a16 16 0 0 1-2 3c-1 1-2 4-4 3s-1 2-2 3c-5 10-5 1-6-4-2 0-2-7-4-7Z"
      />
      <path
        fill="var(--hair)"
        d="M194 381c2 9 9 15 17 17a45 45 0 0 1 6-7c1-1 2 1 2-6l-2-16-2 8c-1 1-2 4-4 3l-3-1c-2-1-2-4-5-4-1 0-2-3-4-3l2-10c-2-1-7 4-7 10v9Z"
      />
      <path
        fill="var(--flesh)"
        d="M342 108c-4 5-6 11-9 16-2 3-4 5-8 5-2-1-4 0-5 2l-2 9c-1 2-2 3-5 3h-6c-3 0-4-1-6-4-4-6-8-13-10-21-2-6-5-14-1-21a3 3 0 0 0 0-3c3 0 3-2 3-5 3 0 2-2 2-4 0-4 0-8 2-11 1-3 2-5 5-4s6 3 6 7a26 26 0 0 1 0 9l1 2c1 1 1 0 2-1l4-7c2-3 4-7 8-8 3-1 4-2 4-5a25 25 0 0 1 0-4c1-6 4-9 10-6 4 1 7 3 11 6 3 1 6 2 9 0 0 7-2 13-3 20-1 1-9 25-12 25Z"
      />
      <path
        fill="var(--hair)"
        d="M357 63c-3 2-6 1-9-1l-4-2c-6-2-11-3-12 3v6c1 3 0 6-3 7-4 1 1 10-1 13-1 3 1 5 1 8 0 21-33-2-36-8-2-10-4-20-4-30 0-8 4-15 8-21a7 7 0 0 1 4-3c7-1 12-6 20-6 8 1 16 5 24 9l15 9c4 1 4 3 4 6-1 4-4 7-7 10Z"
      />
      <path
        fill="var(--pants)"
        d="M298 252c7 2 14 2 22 2a12 12 0 0 1 6 1c5 3 10 2 14-2l3-2c0 2-1 2-2 3l-10 10c-3 2-3 4 0 5a2 2 0 0 1 2 2c-6 4-13 4-19 5a2 2 0 0 1-3-1l-13-22v-1ZM248 272h1a1 1 0 0 0-1 0Z"
      />
      <path
        fill="var(--pants)"
        d="M363 240a4 4 0 0 1-4-2c-6-6-13-10-20-15a24 24 0 0 0 0 3c0 10-7 17-17 17l-27-1c-2-1-13-7-16-6 2 1 6 4 3 3-13-4-43 3-44-9-1-4 0-8-2-11-4-2-9 5-11 7l-6 7c-1 1-10 5-8 13s6 11 8 14a42 42 0 0 0 8 12c8 8 10 4 16 13l5 1h1v1c4 3-1 4 4 6 4 2 29-16 36-12 6 3 18-2 26-2 10 10 35 35 35 17 0-4 26-43 30-42l-17-14Z"
      />
      <path
        fill="var(--shirt)"
        d="m374 159-10 10c-1 1-2 3-4 3-4 1-7 4-10 7-6-1-2 0-4-3l-3 7c-2 5-2 11-3 17l1 6c0 10 4 34-6 34-9 0-17 11-26 11-5-2-24 0-31 0s-29-4-41-17c-6-6-2-19-2-29-2 1-2-36-4-36 0-9 8-17 9-26 1-10 15-32 22-39 12-13 10-6 28-10 1 1 8 9 19 13s29 6 33 1l14 13c8 10 15 20 20 32 1 3-2 4-2 6Z"
      />
    </g>
    <g id="surfer-1">
      <path
        fill="var(--flesh)"
        d="M509 400c-2-2-4-2-7-2h-27a91 91 0 0 1-14-1c-3-1-4-2-4-5a106 106 0 0 0-6-18c-1-7-4-13-3-20a1 1 0 0 0-1 0c-2-8-4-15-4-23a30 30 0 0 0-1-4 94 94 0 0 1-2-15l2-8c-1-3 1-7 1-10a8 8 0 0 1 5-6c5-2 10-4 15-4a101 101 0 0 1 20 3 78 78 0 0 1 19 7c5 2 8 5 7 10 0 7-3 14-6 20-4 8-11 14-18 19a2 2 0 0 1-3 0c-2-2-5-3-6-7-1 4-4 7-4 10l-2 14c-1 5 0 9 2 14 0 6 1 6 6 6 8 0 15 2 23 3 9 1 17 4 26 6 2 0 4 1 3 3s-1 4-4 5a20 20 0 0 1-4 0c-2-1-5 0-6 3Z"
      />
      <path
        fill="var(--hair)"
        d="M46 345a77 77 0 0 0-7 16c-3 8-3 8 5 12a36 36 0 0 1 5 3c4 3 4 7 0 10l-10 4c-9 1-17-1-25-5a9 9 0 0 1-4-6c-2-6-4-12-3-19v-12c0-10-4-18-7-26v-8a57 57 0 0 1 16-3h25c1 0 2-1 1 1l-8 4a4 4 0 0 0-2 3c-2 4-3 9-1 14 3 6 8 11 15 12Z"
      />
      <path
        fill="var(--pants)"
        d="M367 356a14 14 0 0 0-7 4c-5 4-11 6-17 7-17 1-33 3-49 2-15-1-29 1-43 2a31 31 0 0 0-3 1c-6 1-8 0-11-5l-3-12c1-16-2-32-2-48l12-4c3 0 4-1 5-3s2-4 5-4l47-9c7-1 13-4 19-6 10-5 20-8 31-9 9 0 18 1 25 6a7 7 0 0 1 3 3 2 2 0 0 0-2 1c-3 8-4 15-2 23 1 7 2 13-1 20a89 89 0 0 0-4 15c-1 6-1 11-3 16Z"
      />
      <path
        fill="var(--shirt)"
        d="M367 356c2-5 2-10 3-16a89 89 0 0 1 4-15c3-7 2-13 1-20-2-8 0-15 2-23a2 2 0 0 1 2-1c5 0 8 3 13 4 2 5 6 2 9 2a15 15 0 0 1 9 1c3 2 5 2 7 1h8c5 1 10-1 15-2 9-3 19-5 29-5h13a94 94 0 0 1 36 9 78 78 0 0 1 24 18c1 1 4 2 4 5-2 12-4 23-8 35l-15 15c-11 12-25 13-40 11l-11-1c-2-5-3-9-2-14l2-14c0-3 3-6 4-10 1 4 4 5 6 7a2 2 0 0 0 3 0c7-5 14-11 18-19 3-6 6-13 6-20 1-5-3-8-7-10a78 78 0 0 0-19-7 101 101 0 0 0-20-3c-5 0-10 2-15 4a8 8 0 0 0-5 6l-2 10c1 3-1 5-1 8a94 94 0 0 0 2 15 30 30 0 0 1 1 4c0 8 2 15 4 23a1 1 0 0 1 1 0c-1 7 2 13 3 20-12 0-24 0-36 2l-10 1a14 14 0 0 1-9-3c-3-2-7-1-11-1l-16-2c-2 0-2-2-2-3v-12Z"
      />
      <path
        fill="var(--flesh)"
        d="M232 307c0 16 3 32 2 48-13-3-27-2-40-2a98 98 0 0 1-30-5 46 46 0 0 0-19-3c-15 1-28-2-42-4l-18-1h-4c-9 0-19 0-28 3-3 0-5 0-7 2-7-1-12-6-15-13-2-4-1-9 1-14a4 4 0 0 1 2-2l8-4h10l20-1c6-1 13 0 19-2l25-2 33-4h28l21 5a186 186 0 0 0 23 2c4 0 7-3 11-3Z"
      />
      <path
        fill="var(--hair)"
        d="M557 315c4-4 8-5 13-7 10-3 20-4 31-4 11-1 19 9 19 21 1 11-1 22-3 32l-4 16c0 4-4 6-8 4l-7-5 2-3c2-3 4-6 3-9s-2-5-4-4c-3 2-5 1-6-2-1-2-3-3-5-2l-4 1a14 14 0 0 1-10-1c-3-1-3-3-3-6s3-1 5-1l7-1c4 0 5-2 5-6a9 9 0 0 0-7-8l-9-2c-5 0-8-3-11-7l-4-6Z"
      />
      <path
        fill="var(--flesh)"
        d="m557 315 4 6c3 4 6 7 11 7l9 2a9 9 0 0 1 7 8c0 4-1 6-5 6l-7 1c-2 0-4-2-5 1s0 5 3 6a14 14 0 0 0 10 1l4-1c2-1 4 0 5 2 1 3 3 4 6 2 2-1 4 1 4 4s-1 6-3 9l-2 3-9 1c-4 1-7 2-11 1s-7 2-10 4c-5 3-5 3-8-2a2 2 0 0 0-2 0c-5 0-9 0-11-4l-3-1c-4 0-6-1-6-5a30 30 0 0 1 2-10c1-3 0-5-2-7l8-35 11 1ZM482 282h-13c-10 0-20 2-29 5-5 1-10 3-15 2v-6c1-5 6-9 10-8 9 0 19-1 28 3l4 1c5 3 10 3 15 3Z"
      />
      <path
        fill="var(--hair)"
        d="M91 309c-6 2-13 1-19 2l-20 1-1-1c0-7 0-7 7-8 11-1 20 2 30 4l3 2ZM53 343c9-3 19-3 28-3h4l-7 11c-4 6-3 8 3 11 3 2 7 3 6 8-1 4-5 5-8 5a44 44 0 0 1-24-2c-4-2-6-4-5-9l3-21Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>